var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #098988;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24,
    cy: 24,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,22.7l.2-.4c7.6-3,15.3-5.9,22.9-8.8.4,0,.8.2.8.7l-5.8,19.1c-.2.3-.5.4-.8.3l-6.6-4.9-2.6,5.3c-.4.6-1.2.4-1.3-.3v-7.8s-6.3-2.4-6.3-2.4c-.3,0-.4-.3-.5-.5v-.3ZM31.6,16.5l-16.9,6.4,4.5,1.8h.2s12.1-8.2,12.1-8.2ZM34.3,16l-10.7,11.7,5.5,4.1,5.1-15.9ZM20.2,25.9v4.8l1.7-3.4,9.3-9.5-11,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.378871fd99dd98e169a74d8fab7b423b.svg";
export { ForwardRef as ReactComponent };